export const CORRELATION_ID_HEADER = "X-Correlation-ID";

/**
 * Generates a client-side correlation ID for admin -> backend HTTP requests.
 *
 * @remarks
 * The backend echoes `x-correlation-id` in response headers and includes it in request capture logs,
 * so this enables end-to-end correlation across:
 * - HellocashflowAdmin logs
 * - backend request logs (`HelloCashflowNodeJs/logs/telemetry-capture/request-*.log`)
 *
 * This should be stable, safe to log, and unique per request.
 *
 * @see docs/LOGGING.md
 */
export const generateCorrelationId = (): string => {
    const randomUuid =
        typeof globalThis !== "undefined" &&
        "crypto" in globalThis &&
        typeof globalThis.crypto?.randomUUID === "function"
            ? globalThis.crypto.randomUUID()
            : null;

    if (randomUuid) {
        return `hc-admin-${randomUuid}`;
    }

    return `hc-admin-${Date.now()}-${Math.random().toString(16).slice(2, 10)}`;
};
